/* electroshockolyty.js — bundled from js/main.js + js/checkout.js (classic scripts). */

/* ==== main.js ==== */
(function () {
  'use strict';

  /* Mobile nav toggle */
  var burger = document.getElementById('navBurger');
  var navLinks = document.getElementById('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      var isOpen = navLinks.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(isOpen));
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navLinks.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* Scroll-reveal */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Charge meter — fills as the page is scrolled (signature element) */
  var chargeFill = document.getElementById('chargeFill');
  function updateCharge() {
    if (!chargeFill) return;
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - doc.clientHeight;
    var pct = scrollable > 0 ? (doc.scrollTop / scrollable) * 100 : 0;
    chargeFill.style.height = pct + '%';
  }
  document.addEventListener('scroll', updateCharge, { passive: true });
  updateCharge();

  /* FAQ accordion */
  document.querySelectorAll('.faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      var answer = item.querySelector('.faq__a');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.faq__q').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          other.closest('.faq__item').querySelector('.faq__a').style.maxHeight = null;
        }
      });

      btn.setAttribute('aria-expanded', String(!isOpen));
      answer.style.maxHeight = isOpen ? null : answer.scrollHeight + 'px';
    });
  });

  /* Footer year */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  /* Newsletter stub */
  var newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      // TODO: POST the email to the real newsletter/CRM endpoint.
      var btn = newsletterForm.querySelector('button');
      var original = btn.textContent;
      btn.textContent = 'Prihlásené ✓';
      newsletterForm.reset();
      setTimeout(function () { btn.textContent = original; }, 2500);
    });
  }
})();

/* ==== checkout.js ==== */
/**
 * Quantity stepper for the checkout card's OPTION A control (see the
 * HTML comment above the #objednavka section). Purely a UI convenience —
 * the actual checkout/payment flow is handled entirely by the Shopify
 * Buy Button embed (OPTION B), not by this file.
 *
 * If you remove the OPTION A quantity block from index.html in favor of
 * the Buy Button's own quantity/variant picker, this file has nothing
 * left to do and its <script> tag can be deleted too.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var qtyInput = document.getElementById('qtyInput');
    var qtyMinus = document.getElementById('qtyMinus');
    var qtyPlus = document.getElementById('qtyPlus');

    if (!qtyInput || !qtyMinus || !qtyPlus) return;

    function clampQty(value) {
      var n = parseInt(value, 10);
      if (isNaN(n)) n = 1;
      return Math.min(10, Math.max(1, n));
    }

    qtyMinus.addEventListener('click', function () {
      qtyInput.value = clampQty(qtyInput.value) - 1;
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = clampQty(qtyInput.value) + 1;
    });
    qtyInput.addEventListener('change', function () {
      qtyInput.value = clampQty(qtyInput.value);
    });
  });
})();
